import { inject, injectable } from "inversify";
import { BudgetRepository } from "@project/data/repositories/budget.repository";

@injectable()
export class FetchJustificationTemplatesUseCase {
    constructor(
        @inject(BudgetRepository)
        private readonly budgetRepository: BudgetRepository,
    ) { }

    async execute(): Promise<{ id: number; name: string; description: string; version: number; visible: boolean }[]> {
        return this.budgetRepository.fetchJustificationTemplates();
    }
}
